import { IPresentableEntity } from '@/models/available-entities.interface';
import { OrganisationDegrees } from '@studyportals/campaign-management-api-interface';

class EntityNamePresenter {

	public getStylingClassName(entity: IPresentableEntity): string {
		return [
			'EntityName',
			this.getParentRelatedClass(entity),
			this.getOrganisationRelatedClass(entity),
			this.getIndentationRelatedClass(entity),
			this.getHiddenStatusClass(entity)
		].join(' ');
	}

	private getParentRelatedClass(entity: IPresentableEntity): string {
		if (!entity.hasChildren) {
			return '';
		}

		return 'EntityParent';
	}

	private getOrganisationRelatedClass(entity: IPresentableEntity): string {
		if (entity.degreeLevel !== OrganisationDegrees.ORGANISATION &&
			entity.degreeLevel !== OrganisationDegrees.SUBORGANISATION) {
			return '';
		}

		return 'EntityOrganisation';
	}

	private getIndentationRelatedClass(entity: IPresentableEntity): string {
		switch (entity.indentationLevel) {
			case 1:
				return 'EntityChild';
			case 2:
				return 'EntityGrandchild';
			case 3:
				return 'EntityGreatGrandchild';
			case 4:
				return 'EntityGreatGreatGrandchild';
			default:
				return '';
		}
	}

	private getHiddenStatusClass(entity: IPresentableEntity): string {
		if (!entity.hideChildren) {
			return '';
		}

		return 'HideEntityChildren';
	}
}

export default new EntityNamePresenter();
